export default __webpack_public_path__ + "static/media/vino2.316397c7.jpg";